import { render } from "./AllProperties.vue?vue&type=template&id=6ce37012&scoped=true"
import script from "./AllProperties.vue?vue&type=script&lang=js"
export * from "./AllProperties.vue?vue&type=script&lang=js"

import "./AllProperties.vue?vue&type=style&index=0&id=6ce37012&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce37012"]])

export default __exports__